import type { GridColDef } from '@mui/x-data-grid';
import type { PlanOverview } from '@weft/api-definition';
import { PLAN_STATUSES } from '@weft/types';
import cn from 'classnames';
import type { FieldPath } from 'react-hook-form';
import { PlanDotMenu } from '../plans-page-components/PlanDotMenu/PlanDotMenu';

const PLANS_OVERVIEWS_COLUMNS_KEYS = Object.freeze({
  STATUS: 'status',
  NAME: 'name',
  REVENUE: 'revenue',
  TYPE: 'paymentTerm',
  CUSTOMERS: 'customersCount',
} satisfies Record<string, FieldPath<PlanOverview>>);

export const getPlansOverviewsColumns = (refetchFunction: () => void): GridColDef<PlanOverview>[] => [
  {
    field: PLANS_OVERVIEWS_COLUMNS_KEYS.STATUS,
    headerName: 'Status',
    flex: 1,
    headerClassName: 'pl-7',
    cellClassName: 'pl-6',
    renderCell: ({ row }) => {
      return (
        <div className="relative flex items-center font-medium uppercase">
          <span className={cn(
            'font-sans rounded-2lg px-2 py-1',
            { 'bg-[#EBFFEF] text-[#4FBA80]' : row.status === PLAN_STATUSES.Active },
            { 'bg-[#EBFFEF] text-[#DC4F79]' : row.status === PLAN_STATUSES.Error },
            { 'bg-[#FFF7F7] text-inactive' : row.status === PLAN_STATUSES.Inactive },
          )}
          >
            {row.status}
          </span>
        </div>
      );
    },
  },
  {
    field: PLANS_OVERVIEWS_COLUMNS_KEYS.NAME,
    headerName: 'Name',
    flex: 2,
    renderCell: ({ row }) => (
      <span className="font-sans text-black">
        {row.name}
      </span>
    ),
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: PLANS_OVERVIEWS_COLUMNS_KEYS.TYPE,
    headerName: 'Type',
    flex: 2,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: PLANS_OVERVIEWS_COLUMNS_KEYS.CUSTOMERS,
    headerName: 'Customers',
    flex: 2,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'PlanOptionsMenu',
    headerName: '',
    flex: 1,
    align: 'right',
    sortable: false,
    renderCell: ({ row }) => (
      <PlanDotMenu
        refetchFunction={refetchFunction}
        plan={row}
      />
    ),
  },
];
